const OVERFLOW_HIDDEN_CLASS_NAME = 'overflow-hidden'
export const MODAL_SESSION_ATTRIBUTE = 'modal-session-active'

export const startModalSession = () => {
  document.body.classList.add(OVERFLOW_HIDDEN_CLASS_NAME)
  document.body.setAttribute(MODAL_SESSION_ATTRIBUTE, '')
}

export const endModalSession = () => {
  document.body.classList.remove(OVERFLOW_HIDDEN_CLASS_NAME)
  document.body.removeAttribute(MODAL_SESSION_ATTRIBUTE)
}
